import script from "./Social.vue?vue&type=script&setup=true&lang=js"
export * from "./Social.vue?vue&type=script&setup=true&lang=js"

import "./Social.vue?vue&type=style&index=0&id=a1962dfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1962dfe"]])

export default __exports__